import './App.css';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import ExpSection from './ExpSection';
import ResumeView from './ResumeView';
import { ENTRIES } from './experienceData';

const COMPANIES = ENTRIES.filter((e) => e.logo);

function App() {
  const [view, setView] = useState('interactive'); // 'resume' | 'interactive'
  const [activeExpId, setActiveExpId] = useState(ENTRIES[0].id);

  const goToExperience = (id) => {
    setActiveExpId(id);
    setView('interactive');
  };

  return (
    <div className="terminal">
      <header className="hero">
        <p className="prompt">
          <span className="prompt-user">akanksh@portfolio</span>
          <span className="prompt-sep">:~$</span> whoami
        </p>
        <h1 className="name">Akanksh Divyananda</h1>
        <p className="tagline">
          Incoming SWE Intern @ Amazon &middot; MS CS @ UIUC &middot; BS CS @ UC Riverside
        </p>

        <div className="social-icons">
          <a href="https://www.linkedin.com/in/akankshsuhas/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
          <a href="https://github.com/akankshd" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FontAwesomeIcon icon={faGithub} />
          </a>
        </div>

        <p className="exp-icons-label">{'// experiences'}</p>
        <div className="exp-icons">
          {COMPANIES.map((company) => (
            <button
              key={company.id}
              className="exp-icon-btn"
              onClick={() => goToExperience(company.id)}
              aria-label={`View ${company.org} experience`}
              title={company.org}
            >
              <img src={company.logo} alt={company.org} />
            </button>
          ))}
        </div>

        <p className="about-text">
          <span className="comment">{'// about'}</span>
          <br />
          CS grad student building backend and AI systems, most recently at MongoDB, Rakuten,
          and Alaska Airlines. I like taking things apart to understand how they work, then
          building better versions of them.
        </p>
      </header>

      <nav className="view-toggle" aria-label="View switcher">
        <button
          className={`toggle-btn ${view === 'resume' ? 'active' : ''}`}
          onClick={() => setView('resume')}
        >
          $ cat resume.pdf
        </button>
        <button
          className={`toggle-btn ${view === 'interactive' ? 'active' : ''}`}
          onClick={() => setView('interactive')}
        >
          $ ./run --interactive
        </button>
      </nav>

      <main>
        {view === 'resume' ? (
          <ResumeView />
        ) : (
          <ExpSection activeId={activeExpId} onSelect={setActiveExpId} />
        )}
      </main>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Akanksh Divyananda</p>
      </footer>
    </div>
  );
}

export default App;
